module.exports = __webpack_public_path__ + "img/angle_down_small.539482bc.svg";